<template>
	<v-layout>
		<v-row>
			<v-col
				cols="auto"
			>
				<v-card>
					<v-card-title class="d-flex align-center">
						<v-icon
							icon="$alert"
							start
						/>
						<translate>
							Force errors in the log for Sentry
						</translate>
					</v-card-title>
					<v-card-text>
						<v-list>
							<v-list-item
								v-for="button in buttons"
								:key="button.name"
							>
								<v-btn
									block
									color="error"
									@click="sendError(button.url)"
								>
									<translate> {{ button.name }} </translate>
								</v-btn>
							</v-list-item>
						</v-list>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-layout>
</template>

<script>
import axios from 'axios';
import {
	displayError, inform,
} from 'laravel-front-library';

export default {

	data () {
		return {
			buttons: [
				{
					name: 'Send API Error', url: '/bo/testing/errorbuttons/doGenerateErrorApi',
				},
				{
					name: 'Send Frontoffice Error', url: '/bo/testing/errorbuttons/doGenerateErrorFrontoffice',
				},
				{
					name: 'Send Backoffice Error', url: '/bo/testing/errorbuttons/doGenerateErrorBackoffice',
				},
				{
					name: 'Send Cron Error', url: '/bo/testing/errorbuttons/doGenerateErrorCron',
				},
				{
					name: 'Send Invoicing Error', url: '/bo/testing/errorbuttons/doGenerateErrorInvoicing',
				},
			],
		};
	},
	methods: {
		inform,
		displayError,

		/**
		 * Send error to sentry
		 *
		 * @param {string} url The url to send the post request
		 * @returns {void}
		 */
		sendError (url) {
			axios.post(url)
				.then(() => inform(this.$gettext('Error Triggered Successfully')))
				.catch(displayError);
		},

	},
};
</script>
